import { SIZE } from 'common/sizes';
import styled from 'styled-components';

export const RowRoot = styled.div`
  width: 100%;
  padding: 30px 0px 20px 0px;
`;

export const Row = styled.div`
    min-height: 20px;
    display: flex;
    flex-wrap: nowrap;
    flex: 1;
    width:100%;
`;

export const Pages = styled.div`
    font-family: Rubik;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    margin-right: ${SIZE.ONE}px;
`

export const FinalRowRoot = styled.div`
    padding: ${SIZE.TWO}px;
    width: 250px;
    display:inline-block;
    
`;

export const FinalRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    flex: 1;
    flex-direction: row;
    align-items: center;
    line-height: normal;
    letter-spacing: normal;
    color: #272727;
    margin-right:20px;
    justify-content: flex-end;
    padding: ${SIZE.TWO}px;
`;

export const Icon = styled.span`
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 14px;
    position: relative;
`

export const Title = styled.div`
    font-family: Rubik;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;
`

export const Root = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  padding-bottom: 0px;
`;

export const BlankPage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: ${SIZE.HUNDRED}px;
`

export const Image = styled.div`
    margin: ${SIZE.SIX}px 0;
`

export const Message = styled.div`
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
`

export const ListEmty = styled.div`
  padding: 5%  15%;
  text-align: center;  
`

export const Text = styled.div`
  height: 45px;
  width: 100%;
  padding: 20px 0px;
  text-align:center;
  font-size: 20px;
  font-weight: normal;
  color: #122442;
  display: inline-block;
`;

export const Column = styled.div`  
    font-family: Rubik;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #272727;

    flex-direction: column;
    padding: ${SIZE.HALF}px 20px;
    position:relative;
    &:after{
      content: " ";
      position: absolute;
      top: 15%;
      right: 0;
      height: 60%;
      margin-top: auto;
      margin-bottom: auto;
    }
    @media (max-width: 1500px) {
      padding: 15px 15px;
    }
    @media (max-width: 1300px) {
      padding: 15px 12.5px;
    }
`;

export const ListOfItems = styled.div`
    width: 100%;
    height: 100%;
    padding: 0px 0px 0px 0px;    
`

export const PageButton = styled.div`
    &:hover {
        cursor: pointer;
    }
`